import { h } from 'preact'; /** @jsx h */

import './FactsItem.scss';

const FactsItem = ({ isOpen, title, text, onClick, index }) => {
    return (
        <div className={`facts-item ${isOpen ? 'open' : ''}`} onClick={onClick}>
            <div className="facts-item-header">
                <h6 className="facts-item-title">
                    {index}. {title}
                </h6>
                {isOpen ? (
                    <span className="material-symbols-outlined">expand_less</span>
                ) : (
                    <span className="material-symbols-outlined">expand_more</span>
                )}
            </div>
            <p
                className={`facts-item-text ${isOpen ? 'open' : ''}`}
                dangerouslySetInnerHTML={{ __html: text }}
            />
        </div>
    );
};

export default FactsItem;
